import { ShopAndSmileAPIAdapter } from '@bofrak-backend/shared';
import { BASE_URL } from '../constants/environment';

export const apiAdapter = new ShopAndSmileAPIAdapter({
  apiEndpoint: BASE_URL,
  accessToken: '',
  retryCount: 0,
});

/**
 * Build an adapter that carries the decrypted lite access token so
 * authenticated endpoints (products sync, daily counts) work inside the
 * embedded lite webview.
 */
export const createApiAdapter = (accessToken: string) =>
  new ShopAndSmileAPIAdapter({
    apiEndpoint: BASE_URL,
    accessToken,
    retryCount: 0,
  });
